import { BaseCustomSectionAttributes, CustomSectionType } from './common';

export enum AnswerTypeOption {
  SingleChoice = 'SINGLE_CHOICE',
  MultiChoice = 'MULTIPLE_CHOICE',
}
export type ExtractInfoCustomSectionConfig = {
  question?: string;
  aiContext?: string;
  choices: {
    answerType: AnswerTypeOption;
    choices: string[];
    generateNewChoices: boolean;
  };
};
export type ExtractInfoCustomSectionAttributes = BaseCustomSectionAttributes & {
  sectionType: CustomSectionType.ExtractInfo;
  config: ExtractInfoCustomSectionConfig;
};
